import { render, staticRenderFns } from "./SSTAddModal.vue?vue&type=template&id=3d4a5715&scoped=true"
import script from "./SSTAddModal.vue?vue&type=script&lang=js"
export * from "./SSTAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a5715",
  null
  
)

export default component.exports